$(function(){
  $(".u_grid_color").click(function(){
    $(this).parent().find(".u_grid_color").removeClass("custom-active");
    $(this).addClass("custom-active");

    var color_name = $(this).attr('data-val');
    console.log('color name',color_name)
    let a = $(this).closest(".product-card").find("a");
    let img = $(this).closest(".product-card").find("img");

  $(this).parents('.product-card').find(".custom-master-select option").each(function(i){
      if($(this).attr('title').trim().indexOf(color_name) != -1){
        console.log('match',$(this).attr("data-img"))
        a.attr("href", $(this).val());
        if($(this).attr("data-img") != "none"){
          img.attr("srcset", $(this).attr("data-img"));
      }
      }
    });
  });
})